let navigateMiddlewareFn: (to: string) => void;

export const setNavigateMiddleware = (navFn: typeof navigateMiddlewareFn) => {
  navigateMiddlewareFn = navFn;
};

export const navigateMiddleware = (to: string) => {
  if (navigateMiddlewareFn) navigateMiddlewareFn(to);
};

// Store the intended destination before redirecting to login
export const storeRedirectPath = (path: string) => {
  // Remove leading slash and store the path
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  sessionStorage.setItem('redirectEndpoint', cleanPath);
};

export const getRedirectPath = (): string | null => {
  return sessionStorage.getItem('redirectEndpoint');
};

export const clearRedirectPath = () => {
  sessionStorage.removeItem('redirectEndpoint');
};
